import api from "../../../api/axios";

// Feature-local wrappers for the ClientShare endpoints used by the
// /clients/:clientId parent surface.
//
// Endpoints:
//   GET    /api/crm/clients/{client_id}/shares/
//   POST   /api/crm/clients/{client_id}/shares/
//   DELETE /api/crm/clients/{client_id}/shares/{share_id}/
//   GET    /api/crm/clients/{client_id}/share-candidates/
//            — owner-only followed-user picker (Issue #181)
//
// Stateless request wrappers. No cache. No retry. No invalidation.

export const fetchClientShares = (clientId) =>
  api
    .get(`/crm/clients/${clientId}/shares/`)
    .then((res) => res.data);

export const createClientShare = (clientId, body) =>
  api
    .post(`/crm/clients/${clientId}/shares/`, body)
    .then((res) => res.data);

export const deleteClientShare = (clientId, shareId) =>
  api
    .delete(`/crm/clients/${clientId}/shares/${shareId}/`)
    .then((res) => res.data);

/**
 * Owner-only paginated share candidates (followed, verified, eligible).
 * @param {number|string} clientId
 * @param {{ search?: string, page?: number, page_size?: number, signal?: AbortSignal }} [params]
 */
export const fetchShareCandidates = (clientId, params = {}) => {
  const { search = "", page = 1, page_size = 20, signal } = params;
  return api
    .get(`/crm/clients/${clientId}/share-candidates/`, {
      params: {
        search: search || undefined,
        page,
        page_size,
      },
      signal,
    })
    .then((res) => res.data);
};
